import { FormActionType, Pais, PaisDocumento, Persona, TipoRol, TiposDocumento } from "@rpe/registro-personas-empresas-lib";
import { DocumentoPersona } from "../../persona/documentos-persona/documentos-persona.model";
import { ActividadConNombre, Rol } from "../entity-roles/roles.model";


export interface Integrante {
  nombre_completo: string;
  rol: Rol;
  documento_persona: DocumentoPersona;
  correo_electronico?: string;
  cv: File;
  laboratorios_id: number[];
  actividades_id: number[];
  persona?: Persona
}

export function createEmptyIntegrante(): Integrante {
  return {
    rol: null,
    nombre_completo: null,
    documento_persona: null,
    cv: null,
    actividades_id: null,
    laboratorios_id: null,
  };
}

export function createIntegrante(params: any): Integrante {
  return {
    ...createEmptyIntegrante(),
    ...params
  }
}

// form
export interface IntegranteFormInput {
  action: FormActionType;
  tipos_documento: TiposDocumento[];
  paises: Pais[];
  documento_persona: DocumentoPersona;
  tipos_rol: TipoRol[];
  actividadesConNombre: ActividadConNombre[];
  integrante: Integrante;
  entidad_productiva_id: number;
  paises_documento: PaisDocumento[];
}
